import { Link } from 'react-router-dom';

export const Footer = () => {
  return (
    <footer className="bg-[#0e3851] text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Logo ve Açıklama */}
          <div className="lg:col-span-1">
            <img 
              src="https://static.readdy.ai/image/07f91bd9f2ad3b84149b39a4e0627797/2c79e66b2db86b6c99b02e168318d8a7.png" 
              alt="Birsöz İnşaat" 
              className="h-8 w-auto mb-4 brightness-0 invert"
            />
            <p className="text-[14px] text-gray-300 mb-4">
              Güvenilir inşaat çözümleri ile hayalinizdeki projeleri gerçeğe dönüştürüyoruz.
            </p>
            <div className="flex space-x-4">
              <a href="#" className="w-8 h-8 flex items-center justify-center bg-white/10 rounded-full hover:bg-white/20 transition-colors">
                <i className="ri-facebook-fill text-[16px]"></i>
              </a>
              <a href="#" className="w-8 h-8 flex items-center justify-center bg-white/10 rounded-full hover:bg-white/20 transition-colors">
                <i className="ri-instagram-line text-[16px]"></i>
              </a>
              <a href="#" className="w-8 h-8 flex items-center justify-center bg-white/10 rounded-full hover:bg-white/20 transition-colors">
                <i className="ri-linkedin-fill text-[16px]"></i>
              </a>
            </div>
          </div>

          {/* Hızlı Menü */}
          <div>
            <h4 className="text-[16px] font-semibold mb-4">Hızlı Menü</h4>
            <ul className="space-y-2">
              <li><Link to="/" className="text-[14px] text-gray-300 hover:text-white transition-colors">Anasayfa</Link></li>
              <li><Link to="/hakkimizda" className="text-[14px] text-gray-300 hover:text-white transition-colors">Hakkımızda</Link></li>
              <li><Link to="/projeler" className="text-[14px] text-gray-300 hover:text-white transition-colors">Projeler</Link></li>
              <li><Link to="/blog" className="text-[14px] text-gray-300 hover:text-white transition-colors">Blog</Link></li>
              <li><Link to="/iletisim" className="text-[14px] text-gray-300 hover:text-white transition-colors">İletişim</Link></li>
            </ul>
          </div>

          {/* Hizmetler */}
          <div>
            <h4 className="text-[16px] font-semibold mb-4">Hizmetlerimiz</h4>
            <ul className="space-y-2">
              <li><Link to="/arsa-degerlendirme" className="text-[14px] text-gray-300 hover:text-white transition-colors">Arsa Değerlendirme</Link></li>
              <li><Link to="/kiraya-sunulan" className="text-[14px] text-gray-300 hover:text-white transition-colors">Kiralık Birimler</Link></li>
              <li><Link to="/cozum-ortaklari" className="text-[14px] text-gray-300 hover:text-white transition-colors">Çözüm Ortakları</Link></li>
              <li><Link to="/belgeler" className="text-[14px] text-gray-300 hover:text-white transition-colors">Belgeler</Link></li>
            </ul>
          </div>

          {/* İletişim */}
          <div>
            <h4 className="text-[16px] font-semibold mb-4">İletişim</h4>
            <div className="space-y-3">
              <div className="flex items-start">
                <i className="ri-map-pin-line text-[16px] mt-1 mr-3"></i>
                <span className="text-[14px] text-gray-300">
                  Ataşehir, İstanbul<br />
                  Türkiye
                </span>
              </div>
              <div className="flex items-center">
                <i className="ri-phone-line text-[16px] mr-3"></i>
                <a href="tel:+905551234567" className="text-[14px] text-gray-300 hover:text-white transition-colors">
                  +90 555 123 45 67
                </a>
              </div>
              <div className="flex items-center">
                <i className="ri-mail-line text-[16px] mr-3"></i>
                <a href="mailto:info@birsozinsaat.com" className="text-[14px] text-gray-300 hover:text-white transition-colors">
                  info@birsozinsaat.com
                </a>
              </div>
              <div className="flex items-center">
                <i className="ri-whatsapp-line text-[16px] mr-3"></i>
                <a href="https://wa.me/905551234567" className="text-[14px] text-gray-300 hover:text-white transition-colors">
                  WhatsApp
                </a>
              </div>
            </div>
          </div>
        </div>

        {/* Alt Çizgi */}
        <div className="border-t border-white/20 mt-8 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center">
            <p className="text-[14px] text-gray-300 mb-4 md:mb-0">
              © 2024 Birsöz İnşaat. Tüm hakları saklıdır.
            </p>
            <div className="flex space-x-6">
              <Link to="/kvkk" className="text-[14px] text-gray-300 hover:text-white transition-colors">KVKK</Link>
              <Link to="/cerez-politikasi" className="text-[14px] text-gray-300 hover:text-white transition-colors">Çerez Politikası</Link>
              <Link to="/site-haritasi" className="text-[14px] text-gray-300 hover:text-white transition-colors">Site Haritası</Link>
              <a href="https://cdco.com.tr" target="_blank" rel="nofollow" className="text-[14px] text-gray-300 hover:text-white transition-colors">
                Bu web tasarımı CDCO tarafından tasarlanmıştır
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};
